import React from 'react';
import { Currency, getFormattedAmountByCurrency, getMinimumFractionDigitsByCurrency } from './multi-currency-utils';

interface ComponentProps {
  currency?: string | null;
  showCurrencyCode?: boolean;
  value?: number | string;
  enableCurrencyBasedDenomination?: boolean;
  showCommas?: boolean;
}

const addCommas = (amount: string): string => {
  const parts = amount.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

const getFormattedAmount = (amount: number, currency?: string | null) => {
  const options = {
    ...getMinimumFractionDigitsByCurrency(currency),
    useGrouping: false,
  };
  return new Intl.NumberFormat('en-US', options).format(Number(Number(amount).toFixed(2)));
};

export const FormatCurrency = ({
  showCurrencyCode = false,
  value,
  currency,
  enableCurrencyBasedDenomination = false,
  showCommas = false,
}: ComponentProps) => {
  const currencyCode = currency ? currency.toUpperCase() : Currency.USD;
  let amount = typeof value === 'string' ? Number(value) : value;

  if (enableCurrencyBasedDenomination && amount) {
    amount = getFormattedAmountByCurrency(amount, currencyCode);
  }

  return (
    <>
      {amount && amount < 0 ? '-' : ''}
      {showCurrencyCode && `${currencyCode} `}
      {amount
        ? showCommas
          ? addCommas(getFormattedAmount(Math.abs(amount), currencyCode))
          : getFormattedAmount(Math.abs(amount), currencyCode)
        : getFormattedAmount(0, currencyCode)}
    </>
  );
};
